import React from "react";

export const NavegacionConfiguracionInicial = ({
  bloques,
  codigoBloqueActual,
  estadosBloque,
  onSeleccionar,
  onSeleccionarResumen,
  paginaActual,
  mostrarAccesoFinal = false,
  disabled = false,
}) => (
  <div className="ci-sidebar-nav" role="navigation" aria-label="Etapas de configuración inicial">
    {(bloques || []).map((bloque, indice) => {
      const activo = codigoBloqueActual === bloque.Codigo;
      const estado = estadosBloque?.[bloque.Codigo] || "Sin empezar";
      return (
        <button
          type="button"
          key={bloque.Codigo}
          className={`ci-stage-button${activo ? " is-active" : ""}`}
          aria-current={activo ? "step" : undefined}
          disabled={disabled}
          onClick={() => onSeleccionar(bloque)}
        >
          <span className="ci-stage-button__number" aria-label={estado === "Completada" ? "Etapa completada" : undefined}>
            {estado === "Completada" ? "✓" : String(indice + 1).padStart(2, "0")}
          </span>
          <span className="ci-stage-button__copy">
            <strong>{bloque.Titulo}</strong>
            <small>{estado}</small>
          </span>
          {activo && <span className="ci-stage-button__dot" aria-hidden="true" />}
        </button>
      );
    })}
    {mostrarAccesoFinal && (
      <div className="ci-sidebar-shortcuts" aria-label="Accesos directos">
        <span>Accesos directos</span>
        <button
          type="button"
          className={`ci-sidebar-shortcut${paginaActual?.startsWith('PAGINA:') ? " is-active" : ""}`}
          aria-current={paginaActual?.startsWith('PAGINA:') ? "page" : undefined}
          disabled={disabled}
          onClick={onSeleccionarResumen}
        >
          <strong>Finalizar asistente</strong>
          <small>Aplicar mis respuestas y terminar</small>
        </button>
      </div>
    )}
  </div>
);
